import { useSessionTokenGetter } from '@develio/auth/client';
import { useEffect, useState } from 'react';

const API = import.meta.env.VITE_API_URL ?? 'http://localhost:4000';

/**
 * Reports whether the current Clerk user is listed in the API's
 * ADMIN_USER_IDS env var. Used to decide whether to show the sidebar
 * "Admin" section. Failing closed (false) is the safe default — the
 * actual admin endpoints still gate with `isAdminUser()` server-side, so
 * this hook only affects UI visibility.
 */
export function useIsAdmin(): boolean {
  const getToken = useSessionTokenGetter();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = await getToken();
        if (!token) return;
        const res = await fetch(`${API}/api/v1/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return;
        const data = (await res.json()) as { isAdmin?: boolean };
        if (!cancelled && data.isAdmin) setIsAdmin(true);
      } catch {
        // non-fatal — default stays false
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [getToken]);

  return isAdmin;
}
